varying float vBrightness;
varying vec3 vColour;
uniform sampler2D starTexture;

void main(){
    
    // if(length(gl_PointCoord - vec2(0.5, 0.5)) > 0.475)
    //     discard;
    
    float dist=pow(1.-length(gl_PointCoord-vec2(.5,.5)),4.);
    
    gl_FragColor=vec4(vColour+dist*.5,dist+vBrightness);
    gl_FragColor*=texture2D(starTexture,gl_PointCoord);
    
}